module.exports = __webpack_public_path__ + "static/media/home-contact-default.2a918577.jpg";